__turbopack_context__.v({
  "container": "_1abGTq_container",
  "controls--left": "_1abGTq_controls--left",
  "controls--none": "_1abGTq_controls--none",
  "controls--right": "_1abGTq_controls--right",
  "extend": "_1abGTq_extend",
  "faces": "_1abGTq_faces",
  "hasStats": "_1abGTq_hasStats",
  "inner": "_1abGTq_inner",
  "isDfc": "_1abGTq_isDfc",
  "isPartner": "_1abGTq_isPartner",
  "onlyBack": "_1abGTq_onlyBack",
  "onlyFront": "_1abGTq_onlyFront",
  "onlyPartner--first": "_1abGTq_onlyPartner--first",
  "onlyPartner--second": "_1abGTq_onlyPartner--second",
  "side": "_1abGTq_side",
  "size--sm": "_1abGTq_size--sm",
});
